module.exports = __webpack_public_path__ + "static/img/soft_7.6c62fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_7.png
// module id = F6sG
// module chunks = 0